@if (label) {
  <label>{{ label }}</label>
}
<textarea
  nz-input
  [(ngModel)]="internalValue"
  [disabled]="disabled"
  [nzAutosize]="autosize"
  [placeholder]="placeholder"
  (blur)="syncExternalTouched()"
  (ngModelChange)="onModelChange($event)"></textarea>
